// extracted by mini-css-extract-plugin
export default {"container":"ProductList__container___hqCOE","title":"ProductList__title___GptMN","list":"ProductList__list___kv4VM","item":"ProductList__item___nhr4l"};